// eslint-disable
// this is an auto generated file. This will be overwritten

export const onCreateEntity = `subscription OnCreateEntity {
  onCreateEntity {
    id
    name
    legacyId
    tags
    centers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    programs {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onUpdateEntity = `subscription OnUpdateEntity {
  onUpdateEntity {
    id
    name
    legacyId
    tags
    centers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    programs {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onDeleteEntity = `subscription OnDeleteEntity {
  onDeleteEntity {
    id
    name
    legacyId
    tags
    centers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    programs {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onCreateCenter = `subscription OnCreateCenter {
  onCreateCenter {
    id
    name
    legacyId
    tags
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    spaces {
      items {
        id
        name
        version
      }
      nextToken
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onUpdateCenter = `subscription OnUpdateCenter {
  onUpdateCenter {
    id
    name
    legacyId
    tags
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    spaces {
      items {
        id
        name
        version
      }
      nextToken
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onDeleteCenter = `subscription OnDeleteCenter {
  onDeleteCenter {
    id
    name
    legacyId
    tags
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    spaces {
      items {
        id
        name
        version
      }
      nextToken
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onCreateProgram = `subscription OnCreateProgram {
  onCreateProgram {
    id
    name
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onUpdateProgram = `subscription OnUpdateProgram {
  onUpdateProgram {
    id
    name
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onDeleteProgram = `subscription OnDeleteProgram {
  onDeleteProgram {
    id
    name
    entity {
      id
      name
      legacyId
      centers {
        nextToken
      }
      programs {
        nextToken
      }
      version
    }
    groups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onCreateSpace = `subscription OnCreateSpace {
  onCreateSpace {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentGroups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onUpdateSpace = `subscription OnUpdateSpace {
  onUpdateSpace {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentGroups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onDeleteSpace = `subscription OnDeleteSpace {
  onDeleteSpace {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentGroups {
      items {
        id
        name
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onCreateGroup = `subscription OnCreateGroup {
  onCreateGroup {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentSpace {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentGroups {
        nextToken
      }
      version
    }
    program {
      id
      name
      entity {
        id
        name
        legacyId
        version
      }
      groups {
        nextToken
      }
      version
    }
    defaultTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    defaultChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onUpdateGroup = `subscription OnUpdateGroup {
  onUpdateGroup {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentSpace {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentGroups {
        nextToken
      }
      version
    }
    program {
      id
      name
      entity {
        id
        name
        legacyId
        version
      }
      groups {
        nextToken
      }
      version
    }
    defaultTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    defaultChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onDeleteGroup = `subscription OnDeleteGroup {
  onDeleteGroup {
    id
    name
    center {
      id
      name
      legacyId
      entity {
        id
        name
        legacyId
        version
      }
      spaces {
        nextToken
      }
      groups {
        nextToken
      }
      version
    }
    currentSpace {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentGroups {
        nextToken
      }
      version
    }
    program {
      id
      name
      entity {
        id
        name
        legacyId
        version
      }
      groups {
        nextToken
      }
      version
    }
    defaultTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentTeachers {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    defaultChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    currentChildren {
      items {
        id
        name
        legacyId
        version
      }
      nextToken
    }
    version
  }
}
`;
export const onCreateTeacher = `subscription OnCreateTeacher {
  onCreateTeacher {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
export const onUpdateTeacher = `subscription OnUpdateTeacher {
  onUpdateTeacher {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
export const onDeleteTeacher = `subscription OnDeleteTeacher {
  onDeleteTeacher {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
export const onCreateChild = `subscription OnCreateChild {
  onCreateChild {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
export const onUpdateChild = `subscription OnUpdateChild {
  onUpdateChild {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
export const onDeleteChild = `subscription OnDeleteChild {
  onDeleteChild {
    id
    name
    legacyId
    defaultGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    currentGroup {
      id
      name
      center {
        id
        name
        legacyId
        version
      }
      currentSpace {
        id
        name
        version
      }
      program {
        id
        name
        version
      }
      defaultTeachers {
        nextToken
      }
      currentTeachers {
        nextToken
      }
      defaultChildren {
        nextToken
      }
      currentChildren {
        nextToken
      }
      version
    }
    version
  }
}
`;
